import React, { useContext, useEffect, useState } from "react";
import appStyles from "../../app.module.css";
import Api from "../classes/api";
import AppConstants from "../classes/constants";
import AppUtil from "../classes/util";
import ConfigContext from "./../../context/config-context";
import QuoteForm from "./components/quote-form/quote-form";
import QuoteResult from "./components/quote-result/quote-result";
import styles from "./quote.module.css";

const quoteNo = new URLSearchParams(window.location.search).get("qn") || null;

const Quote = () => {
  const { result_url, template } = useContext(ConfigContext);

  const [quoteData, setQuoteData] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);
  const [quoteAccepted, setQuoteAccepted] = useState(false);
  const [isPdfDownloading, setPdfDownloading] = useState(false);

  useEffect(() => {
    if (quoteNo) {
      const loadQuoteData = async () => {
        try {
          setError(null);
          const formData = new FormData();
          formData.append("action", "rsquote_get_common_details");
          formData.append("qn", quoteNo);
          const apiSvc = await Api.getInstance();
          const res = await apiSvc.getData(formData);
          if (res?.data?.success) {
            const quoteResponse = res.data?.data ? res.data.data : null;
            const quoteResult = AppUtil.getFormattedQuoteResult(quoteResponse);
            setQuoteData(quoteResult);
            const quoteAccepted = quoteResult?.actions_details?.find(
              (quoteAction) => quoteAction.action === "quote_accepted"
            );
            quoteAccepted && setQuoteAccepted(true);
          } else {
            setError(AppUtil.getErrorMessage(res));
          }
        } catch (err) {
          setError(AppUtil.getErrorMessage(err));
        }
      };
      loadQuoteData();
    }
  }, []);

  const handleSubmit = async (formData) => {
    try {
      setSubmitting(true);
      setError(null);
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.getData(formData);
      if (res?.data?.success) {
        if (
          template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE &&
          result_url
        ) {
          try {
            window?.gtag("event", "conversion", {
              send_to: "AW-10884794793/QLhPCLDt_YUYEKmTo8Yo",
            });
          } catch (err) {
            setError(AppUtil.getErrorMessage(err));
          }
          window.location.href = `${result_url}/?qn=${res.data?.data?.common_details?.quote_no_encrypted}`;
        } else {
          try {
            // Sending Conversion
            console.log("Sending conversion event");
            window?.gtag("event", "conversion", {
              send_to: "AW-10884794793/wgDJCIHZ_bIDEKmTo8Yo",
            });
            window?.gtag("event", "view_quote", {
              event_category: "quote",
              event_label: "View Quote",
            });
            window?.fbq("track", "Lead");
            window?.fbq("track", "SubmitApplication");
          } catch (err) {
            setError(AppUtil.getErrorMessage(err));
          }
          setQuoteData(res.data?.data ? res.data.data : null);
        }
      } else {
        setError(AppUtil.getErrorMessage(res));
      }
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  const downloadPDF = async (data) => {
    try {
      setPdfDownloading(true);
      setError(null);
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.getData(data);
      if (res?.data?.success) {
        window.open(res?.data?.data, "_blank");
      } else {
        setError(AppUtil.getErrorMessage(res));
      }
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    } finally {
      setPdfDownloading(false);
    }
  };

  const acceptQuote = async (data) => {
    try {
      setSubmitting(true);
      setError(null);
      const apiSvc = await Api.getInstance();
      const res = await apiSvc.getData(data);
      if (res?.data?.success) {
        setQuoteAccepted(true);
        // Sending Conversion
        console.log("Sending conversion event");
        window?.gtag("event", "conversion", {
          send_to: "AW-10884794793/FupaCI3ir7MDEKmTo8Yo",
        });
        window?.gtag("event", "conversion", {
          send_to: "AW-10884877250/I0vACIzZ6L8DEMKXqMYo",
        });
        window?.gtag("event", "conversion", {
          send_to: "AW-10884877250/a9ZECOLv-uAYEMKXqMYo",
        });
        window?.gtag("event", "accept_quote", {
          event_category: "quote",
          event_label: "Accept Quote",
        });
      } else {
        setError(AppUtil.getErrorMessage(res));
      }
    } catch (err) {
      setError(AppUtil.getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className={`${styles.mainWrapper} ${
        template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
          ? appStyles.insideShowcase
          : ""
      }`}
    >
      {quoteData && (
        <QuoteResult
          quoteData={quoteData}
          downloadPDF={downloadPDF}
          acceptQuote={acceptQuote}
          quoteAccepted={quoteAccepted}
          error={error}
          isSubmitting={isSubmitting}
          isPdfDownloading={isPdfDownloading}
        />
      )}
      {!quoteData && !quoteNo && (
        <QuoteForm
          submit={handleSubmit}
          error={error}
          isSubmitting={isSubmitting}
        />
      )}
      {!quoteData && quoteNo && error && (
        <div className={`${appStyles.colorDanger} ${appStyles.textCenter}`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default Quote;
